import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../index'

const networksList = (state: RootState) => state.networks.list
const currentNetworkId = (state: RootState) => state.networks.currentNetworkId
const networksSelectorConfig = (state: RootState) =>
  state.networks.selectorConfig

export const networksListSelector = createSelector(
  [networksList],
  networksList => networksList,
)

export const networksSelectorConfigSelector = createSelector(
  [networksSelectorConfig],
  networksSelectorConfig => networksSelectorConfig,
)

export const currentNetworkIdSelector = createSelector(
  [currentNetworkId],
  currentNetworkId => currentNetworkId,
)

export const currentNetworkSelector = createSelector(
  [networksList, currentNetworkId],
  (networksList, currentNetworkId) =>
    networksList.find(network => network.id === currentNetworkId),
)

export const currentCompanyIdSelector = createSelector(
  [currentNetworkSelector],
  currentNetwork => currentNetwork?.companyId,
)

export const networksLoadingSelector = createSelector(
  [networksList, (state: RootState) => state.networks.loading],
  (networksList, loading) => !networksList?.length && loading,
)

export const defaultNetworkSelector = createSelector(
  [networksList],
  networksList => {
    // TODO: fix that by adding createdAt to networks query and filter them out by oldest createdAt(currently issue with yarn genrate is present)
    return networksList?.find(network => network.id === 'rec4tMkSLWxeAanU9')
  },
)
